const mandatoryCourses = [
  {
    label: 'Manual Handling',
    name: 'manual_handling',
  },
  {
    label: 'Health & Safety',
    name: 'health_safety',
  },
  {
    label: 'Infection Control',
    name: 'infection_control',
  },
  {
    label: 'Safeguarding or Vulnerable Adults',
    name: 'safeguarding_or_vulnerable_adults',
  },
  {
    label: 'Life Support',
    name: 'life_support',
  },
  {
    label: 'First Aid',
    name: 'first_aid',
  },
  {
    label: 'Equality & Diversity',
    name: 'equality_diversity',
  },
  {
    label: 'Fire Safety',
    name: 'fire_safety',
  },
  {
    label: 'Information Governance',
    name: 'information_governance',
  },
  {
    label: 'Food Hygiene',
    name: 'food_hygiene',
  },
];

export default mandatoryCourses;
